import { type TTranscription as TApiTranscription } from '@core/api'

import { type TTranscription } from '@core/models'

export const convertTranscription = (transcription: TApiTranscription): TTranscription => {
    return {
        text: transcription.text,
        error: transcription.error,
        language: transcription.language,
        dateCompleted: transcription.date_completed,
    }
}
